import React from 'react';
import RequestSentComponent from './RequestSentComponent';
import ErrorComponent from '../Errors/ErrorComponent';
import errors from '../Errors/errors';

const CallBackResultComponent = ({props, backToPrivateArea, startOver}) => {
  return !props.data.callBackAlreadyExist ? (
    <RequestSentComponent
      errorReason={props.data.errorReason}
      limited={props.data.selectedAccountExtendedData && props.data.selectedAccountExtendedData.banlvl_pp_limited == 'Y' ? true : false}
      backToPrivateArea={backToPrivateArea}
      startOver={startOver}
      isLogin={props.userData.loginData.isFullAuthenticated || props.userData.loginData.isOtpExtendedAuthenticated}
    />
  ) : (
    <ErrorComponent
      props={{errorData: errors.callback_exist, errorReason: 'callback_exist'}}
      buttonFunction={startOver}
      likeHistoryStep={props.data.allCellularPackagesForAccountData?.length > 1}
    />
  );
};

export default CallBackResultComponent;
